import gql from 'graphql-tag';
import { FLOATING_RATES_FRAGMENT, MANDATARY_RATE_FRAGMENT } from './fragment';

export const EDIT_FLOATING_RATE = gql`
  mutation EditFloatingRate(
    $firstInsurance: Float
    $secondInsurance: Float
    $thirdInsurance: Float
    $firstInstallment: Float
    $secondInstallment: Float
    $thirdInstallment: Float
    $fourthInstallment: Float
    $vat: Float
    $specificOldTax: Float
    $otherOldTax: Float
    $newTax: Float
    $realEstateSecurity: Float
    $honoraires: Float
    $mandataryRates: [MandataryRateInput!]
  ) {
    editFloatingRates(
      input: {
        firstInsurance: $firstInsurance
        secondInsurance: $secondInsurance
        thirdInsurance: $thirdInsurance
        firstInstallment: $firstInstallment
        secondInstallment: $secondInstallment
        thirdInstallment: $thirdInstallment
        fourthInstallment: $fourthInstallment
        vat: $vat
        specificOldTax: $specificOldTax
        otherOldTax: $otherOldTax
        newTax: $newTax
        realEstateSecurity: $realEstateSecurity
        honoraires: $honoraires
        mandataryRates: $mandataryRates
      }
    ) {
      ...FloatingRatesInfo
      mandataryRates {
        ...MandataryRate
      }
    }
  }
  ${FLOATING_RATES_FRAGMENT}
  ${MANDATARY_RATE_FRAGMENT}
`;
